import React, { useState } from 'react';

export default function ThinkyIOTGatewayIntegration({ onBack }) {
  const [gateways] = useState([
    { id: 1, name: 'Gateway A', protocol: 'Modbus', status: 'Online', connectedDevices: 12 },
    { id: 2, name: 'Gateway B', protocol: 'BACnet', status: 'Offline', connectedDevices: 8 },
    { id: 3, name: 'Gateway C', protocol: 'OPC-UA', status: 'Online', connectedDevices: 15 },
    { id: 4, name: 'Gateway D', protocol: 'BLE', status: 'Online', connectedDevices: 20 },
  ]);

  return (
    <div className="min-h-screen bg-black text-white px-4 py-8">
      <button onClick={onBack} className="mb-6 px-4 py-2 bg-blue-600 rounded hover:bg-blue-500 w-24">&larr; Back</button>
      <h1 className="text-lg lg:text-xl font-bold mb-6">IoT Gateway Integration</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {gateways.map(gateway => (
          <div key={gateway.id} className="bg-neutral-900 border border-neutral-800 rounded-2xl p-5 shadow-sm">
            <h3 className="text-lg font-semibold mb-2">{gateway.name}</h3>
            <p>Protocol: <span className="text-blue-400 font-medium">{gateway.protocol}</span></p>
            <p>Status: <span className={`${gateway.status==='Online' ? 'text-green-400' : 'text-red-500'} font-semibold`}>{gateway.status}</span></p>
            <p>Connected Devices: <span className="font-medium">{gateway.connectedDevices}</span></p>
          </div>
        ))}
      </div>

      <section className="mt-8">
        <h2 className="text-lg font-semibold mb-3">Gateway Summary</h2>
        <ul className="list-disc list-inside text-sm">
          <li>Total Gateways: {gateways.length}</li>
          <li>Online: {gateways.filter(g => g.status==='Online').length}</li>
          <li>Offline: {gateways.filter(g => g.status==='Offline').length}</li>
          <li>Total Connected Devices: {gateways.reduce((acc, g) => acc + g.connectedDevices, 0)}</li>
        </ul>
      </section>
    </div>
  );
}
